
<div class="modal-header pb-0">New link</div>
<div class="modal-body" *ngIf="!links &amp;&amp; loading">
  <spinner [text]="'Generating links'|translate"></spinner>
</div>
<div class="modal-body" *ngIf="!links &amp;&amp; !loading" ngForm>
  <div class="list-group mb-4" *ngIf="!isAnonymous()">
    <div class="list-group-item combi single" *ngFor="let recipient of recipients">
      <div class="list-group-main d-flex align-items-center" *ngIf="recipient.id">
        <avatar class="mr-3" size="sm" [user]="recipient"></avatar>
        <div>{{recipient.displayName}}</div>
      </div>
      <div class="list-group-main d-flex align-items-center" *ngIf="recipient &amp;&amp; !recipient.id">
        <avatar class="mr-3" size="sm" [user]="{email: recipient}"></avatar>
        <div>{{recipient}}</div>
      </div>
      <button class="btn btn-link reveal" (click)="removeRecipient(recipient)" title="{{'Remove'|translate}}" *ngIf="recipient"><i class="far fa-trash-alt"><span class="sr-only" translate>Remove</span></i></button>
    </div>
  </div>
  <div class="d-flex align-items-center w-100 mt-3 mb-4">
    <div class="d-flex align-items-center" *ngIf="isAnonymous()">
      <avatar class="mr-3" [user]="null"></avatar><span translate *ngIf="parameters.values.mediaAllowAnonymousLinks">Anonymous link</span><span translate *ngIf="!parameters.values.mediaAllowAnonymousLinks">Select recipients</span>
    </div>
    <div class="mr-auto"></div>
    <button class="btn btn-primary mr-2" (click)="addUser()" data-test-qa="addUser"><i class="far fa-plus"></i><span translate>Users</span></button>
    <button class="btn btn-secondary" (click)="addEmail()" data-test-qa="addEmail"><i class="far fa-plus"></i><span translate>E-mail</span></button>
  </div>
  <div class="form-line clickable" *ngIf="!sectionsExpanded.permissions &amp;&amp; arePermissionsAllowed()" (click)="sectionsExpanded.permissions = true"><i class="far fa-key"></i>
    <div class="header">
      <div class="title" translate>Permissions</div>
      <div class="description" translate>Allow commenting or write access</div>
    </div>
  </div>
  <div class="form-line" *ngIf="sectionsExpanded.permissions &amp;&amp; arePermissionsAllowed()"><i class="fas fa-key text-info"></i>
    <div class="header">
      <div class="title" translate>Permissions</div>
    </div>
  </div>
  <div class="form-line text-muted" *ngIf="!arePermissionsAllowed()"><i class="far fa-key"></i>
    <div class="header">
      <div class="title" translate>Permissions</div>
      <div class="description" translate>Not necessary for a direct download</div>
    </div>
  </div>
  <div class="mb-4 ml-5 align-items-start" [hidden]="!sectionsExpanded.permissions || !arePermissionsAllowed() || advancedPermissionsSelected">
    <media-permission-editor class="mb-3" [presetMode]="true" [(permission)]="requestedPermissions" [maxPermission]="permission"></media-permission-editor>
    <button class="btn btn-secondary btn-block" (click)="advancedPermissionsSelected = true"><i class="fa-fw far fa-key"></i><span translate>Advanced permissions</span></button>
  </div>
  <media-permission-editor class="ml-5" *ngIf="sectionsExpanded.permissions &amp;&amp; arePermissionsAllowed() &amp;&amp; advancedPermissionsSelected" [presetMode]="false" [(permission)]="requestedPermissions" [maxPermission]="permission" [root]="root"></media-permission-editor>
  <div class="form-line clickable" *ngIf="!sectionsExpanded.password" (click)="sectionsExpanded.password = true"><i class="far fa-lock"></i>
    <div class="header">
      <div class="title" translate>Password protection</div>
      <div class="description" translate>Require a password to open this link</div>
    </div>
  </div>
  <div class="form-line" *ngIf="sectionsExpanded.password"><i class="fas fa-lock text-info"></i>
    <div class="header">
      <div class="title" translate>Password protection</div>
      <div class="description" translate>Require a password to open this link</div>
    </div>
    <input class="form-control" type="password" [(ngModel)]="password" name="password" [placeholder]="&quot;Password&quot;|translate" autocomplete="off" autocapitalize="off" autocorrect="off">
  </div>
  <div class="form-line clickable" *ngIf="!sectionsExpanded.expiry" (click)="sectionsExpanded.expiry = true"><i class="far fa-clock"></i>
    <div class="header">
      <div class="title" translate>Automatic expiration</div>
      <div class="description" translate>Link will automatically expire in {{root.shareLinkDuration}} days</div>
    </div>
  </div>
  <div class="form-line" *ngIf="sectionsExpanded.expiry"><i class="fas fa-clock text-info"></i>
    <div class="header">
      <div class="title" translate>Automatic expiration</div>
    </div>
    <input class="form-control" type="text" ngbDatepicker #d="ngbDatepicker" (click)="d.toggle()" [(ngModel)]="expiry" name="expiry" [minDate]="minExpiry" id="sharingModal-expiry">
  </div>
  <div class="form-line clickable" *ngIf="!sectionsExpanded.viewLimit" (click)="sectionsExpanded.viewLimit = true; viewLimit = 3"><i class="far fa-shredder"></i>
    <div class="header">
      <div class="title" translate>View limit</div>
      <div class="description" translate>Limit the number of times the link can be used</div>
    </div>
  </div>
  <div class="form-line" *ngIf="sectionsExpanded.viewLimit"><i class="fas fa-shredder text-info"></i>
    <div class="header">
      <div class="title" translate>View limit</div>
    </div>
    <input class="form-control" type="number" required [(ngModel)]="viewLimit" name="viewLimit" min="0" step="1" id="sharingModal-viewLimit">
  </div>
  <div class="form-line clickable" *ngIf="!sectionsExpanded.linkType &amp;&amp; isLinkTypeAllowed()" (click)="sectionsExpanded.linkType = true"><i class="far fa-paperclip"></i>
    <div class="header">
      <div class="title" translate>Link type</div>
      <div class="description" translate>Embed or link to a direct download</div>
    </div>
  </div>
  <div class="form-line" *ngIf="sectionsExpanded.linkType &amp;&amp; isLinkTypeAllowed()"><i class="fas fa-paperclip text-info"></i>
    <div class="header">
      <div class="title" translate>Link type</div>
    </div>
    <select class="form-control" [(ngModel)]="linkType" name="linkType">
      <option [value]="undefined" translate>Normal</option>
      <option value="download-original" translate *ngIf="permission.allowOriginalDownload">Direct download (original)</option>
      <option value="download-proxy" translate *ngIf="permission.allowProxyDownload">Direct download (proxy)</option>
      <option value="embed-player" translate>Iframe - Player only</option>
      <option value="embed-full" translate>Iframe - Full</option>
    </select>
  </div>
  <div class="form-line text-muted" *ngIf="!isLinkTypeAllowed()"><i class="far fa-paperclip"></i>
    <div class="header">
      <div class="title" translate>Link type</div>
      <div class="description" translate>Cannot be changed when sharing multiple items</div>
    </div>
  </div>
</div>
<div class="modal-footer" *ngIf="!links &amp;&amp; !loading">
  <button class="btn btn-outline-primary" [clickBlocking]="create" [disabled]="!isValid() || !form?.form.valid" data-test-qa="shareButton">
    <translate>Create link</translate>
  </button>
  <button class="btn btn-outline-secondary" (click)="cancel()" translate>Cancel</button>
</div>